<template>
    <div class="content-height-full">
        <prospect-map
            class="content-height-full"
            :prospects="[ prospect ]"
            :can-edit="true"
            :can-draw="true"
        />

        <div class="absolute items-center pin-x pin-b p-lg bg-white shadow flex flex-wrap-reverse justify-between rounded w-2/3 md:w-auto">
            <a :href="route('admin.prospects.show', prospect)" class="btn btn-md is-ghost">
                Avbryt
            </a>

            <button
                class="btn btn-md is-primary mb-md md:mb-0"
                type="button"
                :class="{ 'is-loading': loading }"
                @click="save"
            >
                Spara
            </button>
        </div>
    </div>
</template>

<script>
    import Coordinates from '../../Maps/Coordinates.js';

    export default {
        props: {
            center: {
                required: false,
                type: Object,
                default: () => {
                    return window.defaultMapCenter;
                },
            },
            prospect: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                loading: false,
                initialLoad: true,
                mapLoaded: false,
                drawingInitialized: false,
                shapes: [],
            };
        },
        created() {
            this.coordinates = new Coordinates();

            EventBus.$on(
                'prospects-shapes-drawn',
                (shapes) => {
                    this.shapes = shapes;
                },
            );

            EventBus.$on(
                'shape-drawn',
                (coordinates, shape) => {
                    this.shapes.push(shape);
                },
            );
        },
        methods: {
            async save() {
                this.loading = true;
                const polygons = this.getPolygons();

                try {
                    await axios.patch(route('admin.prospects.area.update', this.prospect), {
                        polygons: polygons,
                    });

                    window.location = route('admin.prospects.show', this.prospect);
                } catch (e) {
                    flash_error('Något gick fel, försök igen!');
                }

                this.loading = false;
            },

            getPolygons() {
                return this.shapes.map((shape) => {
                    const coordinates = this.coordinates.getCoordinatesFromShape(shape);
                    return this.coordinates.getStringifiedCoordinates(coordinates);
                });
            },
        },
    };
</script>